import { setToken, setSession } from "./session_token";
import httpRequest, { setServerConfig } from "./httpreq";
import { isFunction, logStdout } from "../shared/utils";

let timer;
const login = (config, callback) => {
  clearTimeout(timer);
  let { username = "Admin", password = "" } = config;
  setServerConfig(config);
  let opt = {
    cmd: "login",
    body: {
      username: username,
      password: password
    }
  };
  logStdout("login", opt.body.username);
  httpRequest(opt, (data) => {
    let result = {
      message: "OK"
    };
    if (data.message === "OK") {
      setSession(data.obj);
      setToken(data.obj.token);
      result.token = data.obj.token;
    } else {
      setSession();
      setToken();
      result = {
        message: "failed",
        error: data.error
      };
    }
    if (isFunction(callback)) {
      callback(result);
    }
  });
};
export const keepAlive = (callback) => {
  clearTimeout(timer);

  timer = setTimeout(
    () => {
      // getOnePatient(undefined, (data) => {
      //   if (data.message !== 'OK') {
      //     if (data.error && data.error.code === HTTP_ERRORS.tokenError) {
      //       if (callback) callback()
      //     }
      //   }
      // })
      // keepAlive(callback)
      callback();
    },
    20 * 60 * 1000
  );
};
export default login;



// WEBPACK FOOTER //
// ./src/services/login.js